import { defineStore } from 'pinia';
import { readonly, ref, type Ref } from 'vue';

type AlertStore = {
    unreadAlertsCount: Readonly<Ref<number>>,
    setUnreadAlertsCount: (count: number) => void,
};

export const useAlertStore = defineStore('alert', (): AlertStore => {
    const unreadAlertsCount = ref(0);

    const setUnreadAlertsCount = (count: number) => {
        unreadAlertsCount.value = count;
    };

    return {
        unreadAlertsCount: readonly(unreadAlertsCount),
        setUnreadAlertsCount,
    };
});
